// this is an autogenerated file from App/Widget/Content/Questions/Question/Content/CreditCardCapture/mutation-create-lead-person.graphql
import { gql } from 'Data/Api'

let query = gql`
mutation app__App_Widget_Content_Questions_Question_Content_CreditCardCapture{
  leads_create_lead_person {
    person {
      _id
      first_name
      last_name
    }
    responsible_person {
      _id
      first_name
      last_name
    }
    location_id
  }
}

`
export default query
